export default class Point {
  constructor(x, y, time = new Date().getTime()) {
    this.x = x;
    this.y = y;
    this.time = time;
  }

  velocityFrom(start) {
    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
  }

  distanceTo(start) {
    return Math.sqrt((this.x - start.x) * (this.x - start.x) + (this.y - start.y) * (this.y - start.y));
  }
}
